export default "__VITE_ASSET__BbJKXaYz__"